import { render, staticRenderFns } from "./showVendorRequest.vue?vue&type=template&id=6f97c4f7"
import script from "./showVendorRequest.vue?vue&type=script&lang=js"
export * from "./showVendorRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports